<template>
  <div>
    <h1>Configurador de Entrada de Manutenção</h1>
    <router-link :to="'/checklist/vehicleRevisionEntry/list'">
      <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
    </router-link>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <RevisionEntryConfigurationCrud
      :model.sync="config"
      :submitted.sync="submitted"
    ></RevisionEntryConfigurationCrud>

    <b-button @click="handleSave" :disabled="submitted">Salvar</b-button>
  </div>
</template>

<script>
export default {
  name: "RevisionEntryConfiguration",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    RevisionEntryConfigurationCrud: () =>
      import(
        "@/components_rms/vehicle/Revision/RevisionConfigurations/RevisionEntryConfigurationCrud.vue"
      ),
  },
  data() {
    return {
      config: [],
      alert: {
        error: "",
        success: "",
      },
      submitted: false,
    };
  },
  methods: {
    async handleSave() {
      this.submitted = true;
      this.$apiChecklist
        .post("/entryConfiguration/save/", this.config)
        .then((response) => {
          this.config = response.data;
          this.alert.success = "Configuração salva com sucesso!";
          this.$refs.alert.show();
          this.submitted = false;
        })
        .catch((error) => {
          console.error(error);
          this.alert.error = "Erro ao salvar configuração";
          this.$refs.fadeAlertDanger.show();
          this.submitted = false;
        });
    },
    prevPage() {
      this.tableCurrentPage--;
      this.$refs.table.refresh();
    },
  },
  async mounted() {
    this.submitted = true;
    this.$apiChecklist
      .get("/entryConfiguration/get/")
      .then((response) => {
        this.config = response.data;
        this.submitted = false;
      })
      .catch((error) => {
        console.error(error);
        this.alert.error = "Erro ao carregar configuração";
        this.$refs.fadeAlertDanger.show();
        this.submitted = false;
      });
  },
};
</script>

<style scoped>
/* Your styles here */
</style>